import { createSelector,createSlice } from '@reduxjs/toolkit';
import { defaultFiltersWithStatus, FiltersWithStatus } from 'common/types/FiltersWithStatus';
import { getReducers, statusesList } from 'common/utils/statusHelpers';

type StateWithRoleUserMembership = { roleUserMembership: FiltersWithStatus };

const initialState = defaultFiltersWithStatus;

const roleUserMembershipSlice = createSlice({
    name: 'roleUserMembership',
    initialState,
    reducers: getReducers()
});

// eslint-disable-next-line no-restricted-syntax
export default roleUserMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkStatusFilter } = roleUserMembershipSlice.actions;
export const selectFilters = (state: StateWithRoleUserMembership) => state.roleUserMembership.filters;

// Memoized selector to prevent unnecessary rerenders
const selectStatusKeys = (state: StateWithRoleUserMembership) => state.roleUserMembership.filters.dropdowns.status.keys;

export const selectFilteredStatus = createSelector(
    [selectStatusKeys],
    (statusKeys) => statusesList.filter(statusName => statusKeys.includes(statusName))
);
